import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles/index';
import CurrencySelectSearchfield from './CurrencySelectSearchfield';
import CurrencySelectList from './CurrencySelectList';

const styles = {
  active: {
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
  },
  flex: {
    flex: 1,
    color: '#c2c2c',
    fontWeight: '400',
    fontSize: '1rem',
    fontFamily: "'Roboto Mono', monospace",
  },

};

class CurrencySelectDialog extends Component {
  state = {
    searchString: '',
  };

  onClose = () => {
    this.setState({ searchString: '' });
    this.props.onClose();
  };

  handleClick = (event) => {
    this.props.onChange(event);
    this.onClose();
  };

  updateSearchString = (event) => {
    this.setState({ searchString: event.target.value.toLowerCase() });
  };

  render() {
    const {
      open, title, classes, selectedCurrency,
    } = this.props;

    return (
      <Dialog
        fullScreen
        fullWidth
        maxWidth="md"
        open={open}
        onClose={this.onClose}
      >
        <AppBar className="DialogBar" position="static" elevation={2}>
          <div className="Content-wrapper ">
            <div className="content">
              <Toolbar disableGutters>
                <Typography variant="title" color="inherit" className={classes.flex}>
                  {title}
                </Typography>
                <IconButton onClick={this.onClose} aria-label="Schließen">
                  <CloseIcon style={{ color: 'white' }} />
                </IconButton>
              </Toolbar>
            </div>
          </div>
        </AppBar>


        <DialogContent>
          <div className="Content-wrapper ">
            <div className="content">
              <CurrencySelectSearchfield onChange={this.updateSearchString} />
              <CurrencySelectList
                onClick={this.handleClick}
                selectedCurrency={selectedCurrency}
                searchString={this.state.searchString}
              />
            </div>
          </div>
        </DialogContent>

      </Dialog>
    );
  }
}

CurrencySelectDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  selectedCurrency: PropTypes.string.isRequired,
};

CurrencySelectDialog.defaultProps = {
  open: false,
};

export default withStyles(styles)(CurrencySelectDialog);



// WEBPACK FOOTER //
// ./src/components/calculator/currency-select/CurrencySelectDialog.js